import React, { useEffect, useState, useRef } from "react";
import "./EconomicNewsCards.css";
import Header from "./header/header";
import NavBar from "./nav/nav-bar";
import Masonry from "react-masonry-css";
import ClipLoader from "react-spinners/ClipLoader";
import play from "./assets/images/play.svg";
import pause from "./assets/images/pause.svg";
import Footer from "./footer/footer";
import Service from "./webservice/http";

export default function EconomicNewsCards() {
  const Services = new Service();

  const [articles, setArticles] = useState([]);
  const [playingIdx, setPlayingIdx] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState({});
  const [durations, setDurations] = useState({});
  const [elapsed, setElapsed] = useState({});
  const utteranceRefs = useRef({});
  const progressIntervalRef = useRef(null);
  const [openmodal, setOpenmodal] = useState(false);
  const [text, setText] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const [waveformBars, setWaveformBars] = useState(Array(20).fill(0));
  const animationRef = useRef();
  const audioRef = useRef(null);
  const [newsid, setNewsid] = useState(null);
  // const [newsduration, setNewsduration] = useState(0)

  const [audioloader, setAudioloader] = useState(false);

  useEffect(() => {
    setLoading(true);
    Services.get("api/product/news")
      .then((data) => {
        // console.log("Articles fetched:", data.articles);
        setArticles(data.articles);
        setLoading(false);
      })
      .catch((error) => {
        // console.error("Error fetching articles:", error);
        setError("Failed to fetch articles");
        setLoading(false);
      });
  }, []);

  const formatTime = (ms) => {
    const totalSec = Math.floor(ms / 1000);
    const min = Math.floor(totalSec / 60);
    const sec = totalSec % 60;
    return `${min}:${sec.toString().padStart(2, "0")}`;
  };

  const titleMap = {};
  const filteredData = articles?.filter((art) => {
    if (!art.title || titleMap[art.title]) return false;
    titleMap[art.title] = true;
    return true;
  });

  // console.log("hyhy", filteredData);

  const handlePlayPause = async (idx, articleId, id) => {
    const isPlaying = playingIdx === idx;

    if (isPlaying) {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
      clearInterval(progressIntervalRef.current);
      setProgress((prev) => ({ ...prev, [idx]: 0 }));

      setElapsed((prev) => ({ ...prev, [idx]: 0 }));
      setPlayingIdx(null);
      return;
    }

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    clearInterval(progressIntervalRef.current);
    setProgress((prev) => ({ ...prev, [idx]: 0 }));
    setElapsed((prev) => ({ ...prev, [idx]: 0 }));

    try {
      const response = await Services.get(`api/product/news/?article_id=${id}`);

      if (!response) {
        throw new Error("Invalid response from API");
      }

      const { audio_url, duration } = response;
      // console.log(duration);
      const formattedDuration =
        Number(String(duration).replace(/[^\d.]/g, "")) * 1000;

      console.log(typeof formattedDuration, formattedDuration);

      const audio = new Audio(audio_url);
      audioRef.current = audio;

      audio.onended = () => {
        clearInterval(progressIntervalRef.current);
        setProgress((prev) => ({ ...prev, [idx]: 100 }));
        setElapsed((prev) => ({ ...prev, [idx]: formattedDuration }));
        setPlayingIdx(null);
      };

      const startTime = Date.now();
      progressIntervalRef.current = setInterval(() => {
        const now = Date.now();
        const elapsedMs = now - startTime;
        console.log(elapsedMs, formattedDuration);
        const percent = Math.min(100, (elapsedMs / formattedDuration) * 100);
        setProgress((prev) => ({ ...prev, [idx]: percent }));
        setElapsed((prev) => ({ ...prev, [idx]: elapsedMs }));
        if (percent >= 100) clearInterval(progressIntervalRef.current);
      }, 200);

      audio.play();
      setPlayingIdx(idx);
      setDurations((prev) => ({ ...prev, [idx]: formattedDuration }));
    } catch (error) {
      console.error("Error playing audio:", error);
      alert("Failed to play audio. Please try again.");
    }
  };

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
      clearInterval(progressIntervalRef.current);
    };
  }, []);

  console.log("ppppppppppppp", progress);
  // const handlePlay = () => {
  //   if (text.trim()) {
  //     const utterance = new SpeechSynthesisUtterance(text);
  //     utterance.lang = "en-SG";
  //     speechSynthesis.speak(utterance);
  //   }
  // };
  const ttsAudioRef = useRef(null);
  // console.log(ttsAudioRef);

  const handlePlayTts = async () => {
    if (!isPlaying && ttsAudioRef.current) {
      await ttsAudioRef.current.play();
      setIsPlaying(true);
      return;
    }

    setAudioloader(true);

    if (text.trim()) {
      try {
        const response = await Services.post("api/product/text-to-voice/", {
          text: text,
        });

        setAudioloader(false);

        if (ttsAudioRef.current) {
          ttsAudioRef.current.pause();
          ttsAudioRef.current.currentTime = 0;
        }

        const audio = new Audio(response?.audio_url);
        ttsAudioRef.current = audio;

        setIsPlaying(true);

        audio.onended = () => setIsPlaying(false);
        audio.onerror = () => setIsPlaying(false);

        await audio.play();
      } catch (error) {
        console.error("Error playing TTS:", error);
        setIsPlaying(false);
        setAudioloader(false);
      }
    } else {
      setAudioloader(false);
    }
  };

  const handleStop = () => {
    if (ttsAudioRef.current && !ttsAudioRef.current.paused) {
      ttsAudioRef.current.pause();
    }
    setIsPlaying(false);
  };

  useEffect(() => {
    if (openmodal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openmodal]);

  useEffect(() => {
    if (isPlaying) {
      const animateWaveform = () => {
        setWaveformBars((prev) => prev.map(() => Math.random() * 100 + 10));
        animationRef.current = setTimeout(animateWaveform, 100);
      };
      animateWaveform();
    } else {
      clearTimeout(animationRef.current);
      setWaveformBars(Array(20).fill(10));
    }

    return () => clearTimeout(animationRef.current);
  }, [isPlaying]);

  return (
    <div className="dashboard-body">
      <Header />
      <NavBar />
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <ClipLoader color="#2056FF" size="50px" />
        </div>
      ) : (
        <div className=" EconomicNewsCards mt-4">
          <div className="flex justify-end px-10">
            <button
              className="px-6 py-3 mt-8 text-black rounded-lg shadow  bg-white hover:opacity-90 transition hover:bg-blue-900 hover:text-white hover:shadow-lg font-medium"
              style={{ fontSize: "14px", fontWeight: "" }}
              onClick={() => setOpenmodal(true)}
              aria-label="Text to Voice"
            >
              Text To Speech
            </button>
          </div>
          <div className="min-h-screen py-12 px-4 sm:px-8 md:px-16 lg:px-52  flex flex-wrap gap-8">
            {filteredData?.map((art, idx) => (
              <div
                key={idx}
                className="relative shadow-xl overflow-hidden flex flex-col p-10 mb-6"
                style={{
                  width: "350px",
                  borderRadius: "30px",
                  backgroundColor: "#FDFAF8",
                  height: "485px",
                }}
              >
                <div
                  className="text-3xl text-gray-500"
                  style={{ lineHeight: "20px" }}
                >
                  NEWS
                </div>
                <h2
                  className="mt-4 mb-8 text-4xl font-semibold text-black"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {art.title}
                </h2>
                <div className="relative flex-1 mt-2 bg-gray-200 rounded-lg">
                  {!art.image ? (
                    <div
                      className="flex items-center justify-center gap-2 h-44 "
                      style={{ backgroundColor: "#FDFAF8" }}
                    >
                      {[
                        10, 30, 40, 60, 70, 40, 55, 95, 70, 100, 80, 85, 95,
                        100, 85, 95, 60, 75, 80, 75, 40, 30, 40, 80, 95, 70,
                        100, 80, 85,
                      ].map((height, i) => (
                        <div
                          key={i}
                          className="w-[2px] rounded-full"
                          style={{
                            height: `${height}%`,
                            background: `linear-gradient(to top, #f59e0b, #ef4444)`,
                          }}
                        >
                          .
                        </div>
                      ))}
                    </div>
                  ) : (
                    <img
                      src={art.image}
                      alt={art.title}
                      className={`w-full object-cover transition-filter duration-500 ${
                        playingIdx === idx ? "filter blur-sm opacity-60" : ""
                      }`}
                      style={{ height: "160px" }}
                    />
                  )}

                  <div
                    className={`absolute top-0 left-0 w-full h-full flex items-end justify-around bg-black/40 pb-3 ${
                      playingIdx === idx ? "flex" : "hidden"
                    }`}
                  >
                    {Array.from({ length: 8 }).map((_, i) => (
                      <div
                        key={i}
                        className="bar w-2 bg-orange-500 rounded-sm animate-bounce"
                        style={{
                          animationDelay: `${i * 0.15}s`,
                          animationDuration: "0.6s",
                        }}
                      />
                    ))}
                  </div>
                </div>
                <div className="controls flex flex-col py-2 mt-4">
                  <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center">
                      <button
                        onClick={() =>
                          // setNewsid(art?.id);
                          handlePlayPause(
                            idx,
                            art.description || art.content || art.title,
                            art.id
                          )
                        }
                        className={`w-16 h-16 bg-white rounded-full shadow-md flex items-center justify-center ${
                          playingIdx === idx ? "rotate-180" : ""
                        }`}
                        aria-label="Play/Pause"
                      >
                        <img
                          src={playingIdx === idx ? pause : play}
                          alt={playingIdx === idx ? "Pause" : "Play"}
                          className="w-10 h-10"
                        />
                      </button>
                    </div>
                    <div className="w-full h-2 bg-gray-300 rounded-full mt-3">
                      <div
                        className="h-full bg-red-600 rounded-full transition-all duration-200"
                        style={{
                          width: `${progress[idx] || 0}%`,
                        }}
                      ></div>
                      <div className="text-sm text-gray-500 mt-2">
                        {formatTime(elapsed[idx] || 0)} / {art?.duration || 0}
                      </div>
                    </div>
                  </div>
                </div>

                <p
                  className="px-4 mt-2 text-gray-600 flex-grow font-normal"
                  style={{
                    fontSize: "16px",
                    lineHeight: "20px",
                    display: "-webkit-box",
                    WebkitLineClamp: 4,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {art.description || "No description available."}{" "}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
      {openmodal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div
            className="p-6 rounded-2xl shadow-2xl bg-white text-black"
            style={{ width: "500px" }}
          >
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                    />
                  </svg>
                </div>
                <h2 className="text-2xl font-semibold text-black ">
                  Text to Speech
                </h2>
              </div>
              <button
                onClick={() => {
                  setOpenmodal(false);
                  ttsAudioRef.current.pause();
                  ttsAudioRef.current.currentTime = 0;
                  ttsAudioRef.current = null;
                  setIsPlaying(false);
                  setText("");
                }}
                className="text-slate-400 hover:text-red-600 transition-colors p-1 font-bold"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="mb-4">
              <textarea
                className="w-full p-4  rounded-xl text-black placeholder-slate-400  focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all resize-none"
                rows="5"
                placeholder="Enter your text here..."
                value={text}
                onChange={(e) => setText(e.target.value)}
                maxLength={10000}
                style={{
                  border: "1px solid #e2e8f0",
                  backgroundColor: "#f8fafc",
                }}
              />
              <div className="text-xs text-slate-400 mt-2 text-right">
                {text.length}/10000 characters
              </div>
            </div>
            {isPlaying && (
              <div className="mb-6">
                <div className="flex items-center justify-center space-x-1 h-12 bg-slate-800/30 rounded-lg p-2">
                  {waveformBars.map((height, index) => (
                    <div
                      key={index}
                      className={`w-1 bg-gradient-to-t rounded-full transition-all duration-100 ${
                        isPlaying
                          ? "from-blue-400 to-purple-500"
                          : "from-slate-600 to-slate-500"
                      }`}
                      style={{
                        height: `${Math.max(height * 0.4, 8)}px`,
                        animation: isPlaying
                          ? `pulse-${
                              index % 3
                            } 0.6s ease-in-out infinite alternate`
                          : "none",
                      }}
                    />
                  ))}
                </div>
              </div>
            )}

            <div className="flex items-center justify-center space-x-3">
              {audioloader ? (
                <button
                  onClick={handleStop}
                  className="flex items-center space-x-2 bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 text-white px-6 py-3 rounded-xl font-medium transition-all duration-200 shadow-lg hover:shadow-xl"
                >
                  <ClipLoader color="white" size={20} />
                  <span>Loading...</span>
                </button>
              ) : !isPlaying ? (
                <button
                  onClick={handlePlayTts}
                  disabled={!text.trim()}
                  className={`flex items-center space-x-2 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 disabled:from-slate-600 disabled:to-slate-700 text-white px-6 py-3 rounded-xl font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl ${
                    !text.trim() ? "cursor-not-allowed opacity-50" : ""
                  }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    fill="white"
                    viewBox="0 0 24 24"
                  >
                    <path d="M8 5v14l11-7z" />
                  </svg>
                  <span>Play</span>
                </button>
              ) : (
                <button
                  onClick={handleStop}
                  className="flex items-center space-x-2 bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 text-white px-6 py-3 rounded-xl font-medium transition-all duration-200 shadow-lg hover:shadow-xl"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 10h6v4H9z"
                    />
                  </svg>
                  <span>Pause</span>
                </button>
              )}
            </div>
          </div>

          <style jsx>{`
            @keyframes pulse-0 {
              0%,
              100% {
                transform: scaleY(0.8);
              }
              50% {
                transform: scaleY(1.2);
              }
            }
            @keyframes pulse-1 {
              0%,
              100% {
                transform: scaleY(1.1);
              }
              50% {
                transform: scaleY(0.9);
              }
            }
            @keyframes pulse-2 {
              0%,
              100% {
                transform: scaleY(0.9);
              }
              50% {
                transform: scaleY(1.3);
              }
            }
          `}</style>
        </div>
      )}

      <Footer />
    </div>
  );
}
